import Wujie from '@/components/wujie'

export default {
  routes: [

    // 收凭证
    {
      path: 'income',
      component: Wujie,
      props: { type: 'erp-vue3' },
      children: [
        { path: 'index', meta: { title: "收入凭证" } },
        { path: 'detail', meta: { title: "收入明细" } },
        { path: 'check-flow', meta: { title: "人工填报审核" } },
        { path: 'claim', meta: { title: "补认领管理" } },
        { path: 'unclaimed', meta: { title: "未认领报审" } },
      ]
    },

  ]
}



// WEBPACK FOOTER //
// ./src/router/erp-vue3.js